import Gradient from '@ui/effects/Gradient'
import { colors } from '@ui/colors'

export default function Separator() {
  return (
    <Gradient
      colors={[
        colors.black0,
        colors.black10,
        colors.black10,
        colors.black10,
        colors.black0,
      ]}
      start={[0, 0.5]}
      end={[1, 0.5]}
      style={[{ height: 1 }]}
    />
  )
}
